import React, { useCallback, useId } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  bool, func, number, shape, string,
} from 'prop-types'

import { formatFileSize } from './formatFileSize'

// `showArchiveName` is set when the item ships several archives, where two entries can share
// a path and only the archive tells them apart.
function FileOption({
  value, candidate, isSelected, showArchiveName = false, onSelect,
}) {
  const {
    name, entryPath, format, fileSize, archiveName,
  } = candidate
  const inputId = useId()
  const handleChange = useCallback(() => onSelect(value), [onSelect, value])
  const details = [format?.toUpperCase(), formatFileSize(fileSize)].filter(Boolean).join(' - ')
  const location = [showArchiveName && archiveName, entryPath !== name && entryPath].filter(Boolean).join('/')

  return (
    <label
      htmlFor={inputId}
      className={classnames('archive-file-option', isSelected && 'archive-file-option--selected')}
    >
      <input
        id={inputId}
        type="radio"
        name="archive-file"
        className="archive-file-option__input"
        value={value}
        checked={isSelected}
        onChange={handleChange}
      />
      <span className="archive-file-option__text">
        <span className="archive-file-option__name cgt-body-base-semibold">{name}</span>
        {location && <span className="archive-file-option__path cgt-caption">{location}</span>}
      </span>
      {details && <span className="archive-file-option__details cgt-caption">{details}</span>}
    </label>
  )
}

FileOption.propTypes = {
  value: string.isRequired,
  candidate: shape({
    name: string.isRequired,
    entryPath: string.isRequired,
    format: string,
    fileSize: number,
    archiveName: string,
  }).isRequired,
  isSelected: bool.isRequired,
  showArchiveName: bool,
  onSelect: func.isRequired,
}

export default FileOption
